import { State } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
  ProductBuilderMachineStateSchema,
} from '../types';
import { getStateKey } from './getStateKey';
import { getStates } from './getStates';

type IsInitialState = (
  state: State<
    ProductBuilderMachineContext,
    ProductBuilderMachineEvent,
    ProductBuilderMachineStateSchema
  >,
) => boolean;

export const isInitialState: IsInitialState = state => {
  const states = getStates(state.context);
  const stateKey = getStateKey(state.value);
  return states.indexOf(stateKey) === 0;
};
